/**
 * Motor de template de mensagem: interpola variáveis `{{chave}}` e resolve
 *
 * API pública:
 * - `interpolate({ rawString, context })` — motor genérico.
 * - `resolveWhatsappContext(...)` — especialista de contexto do WhatsApp.
 *
 * Peças internas (`engine/`, `conditions/`) não fazem parte da API pública e
 * não devem ser importadas de fora deste módulo.
 */
export { interpolate } from "./engine/interpolate";
export { resolveWhatsappContext } from "./contexts/whatsapp";
export type { TemplateNode, InterpolateArgs } from "./types";
export type {
  WhatsappTrackingPayload,
  WhatsappContextResult,
  ResolveWhatsappContextArgs,
} from "./contexts/whatsapp";
